













































import { Component, Mixins } from "vue-property-decorator";
import CommonMixin, {
  WORKFLOW_PREFERRED_GREAT_START,
} from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";
import { WorkflowService } from "@/service/workflow.service";
import PageLoader from "@/components/PageLoader.vue"
import { ContentService } from "@/service/content.service";
import { MatchGSRPLikelyReferralContent } from "@/models/content/match-gsrp-likely-referral";

@Component({
  components: {
    PageLoader
  },
})
export default class MatchGSRPLikelyReferral extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  content: MatchGSRPLikelyReferralContent = {} as MatchGSRPLikelyReferralContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchGSRPLikelyReferralContent();
      this.textDirection = contentService.TextDirection();  
      await this.loadData();
    } catch (error) {
      this.showError(error as any);
    }
  }

  async loadData(): Promise<void> {
      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchGSRPLikelyReferral") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
    this.loadDataFinished = true;
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }

  public async handleLearnMore(): Promise<void> {
    window.open( this.content.LearnMoreUrl, "_blank"); 
    await this.publishWebLearnMoreClickEvent( this.appData.workflowId) 
  }
}
